import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';
import { Translate } from 'react-localize-redux';
import { CallHistoryMethodAction, goBack } from 'connected-react-router';

import styled from 'styled-components';

import { UPDATE_USER } from '@webapp/store/user/actions';
import { DeleteUser } from '@webapp/store/user/action-creators';

import Button from '@components/actions/button';
import BackIcon from '@components/basics/icons/back';
import Typography from '@components/basics/typography';
import ButtonFixed from '@components/layout/button-fixed';
import MotionOpacity from '@components/motion/motion-opacity';
import UserArtistList from '@webapp/controllers/user/user-artist-list';
import User from '@common/types/user/user';

interface ProfileDeactivatePageProps {
  className?: string;
  isLoading: boolean;
  username: string;
  user: Partial<User>;
  profileCount: number;
  deleteUser: (user: Partial<User>) => DeleteUser;
  goBack: () => CallHistoryMethodAction;
}

const mapStateToProps = (state: AppState) => ({
  isLoading: !!state.ui.loading[UPDATE_USER],
  user: state.user.profile,
  username: state.user.profile?.username,
  profileCount: state.artist.myArtists.length,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goBack: () => dispatch(goBack()),
  deleteUser: (user: Partial<User>) => dispatch(new DeleteUser(user))
});

export const ProfileDeactivatePage: React.FC<ProfileDeactivatePageProps> = ({
  deleteUser,
  ...props
}) => {

  return (
    <MotionOpacity>
      <div className={props.className}>
        <BackIcon className='btn mb-50' onClick={() => props.goBack()} />
        <Typography className='mb-10' type='subheader' weight='400'>
          <Translate id='USER_PROFILE.DEACTIVATE.LIST.TITLE' /> {props.username}
        </Typography>
        <Typography className='mb-60' opacity='.5' weight='700'>
          There {props.profileCount >= 2 ? 'are' : 'is'} {props.profileCount} profile{props.profileCount >= 2 ? 's' : ''} associated with this account
        </Typography>
        <UserArtistList />
        <ButtonFixed>
          <Button className='deactivate-btn' onClick={() => deleteUser(props.user)}>
            <Translate id='USER_PROFILE.DEACTIVATE.BUTTON' />
          </Button>
        </ButtonFixed>
      </div>
    </MotionOpacity>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ProfileDeactivatePage)`
  margin-bottom: 100px;
  @media ${({ theme }) => theme.device.laptopS} {
    margin-bottom: 0;
  }
`);
